export * from '@primeuix/themes/nora/checkbox';
export { default } from '@primeuix/themes/nora/checkbox';
